import React, { useState, useEffect } from "react";
import cx from "ui/cx";
import styles from "./Autosave.module.scss";

export type AutosaveStates = "saving" | "saved" | "";

export interface AutosaveProps extends React.HTMLAttributes<HTMLDivElement> {
  autosave: AutosaveStates | undefined;
}

export default function Autosave({ autosave, className, ...props }: AutosaveProps) {
  return (
    <div className={cx(styles.wrapper, className)} {...props}>
      {/*  TODO - add icons */}
      {autosave === "saving" && <>Saving...</>}
      {autosave === "saved" && <>Saved</>}
    </div>
  );
}

export function useAutosave() {
  const state = useState<AutosaveStates>("");
  const [autosaveState, setAutosaveState] = state;

  useEffect(() => {
    if (autosaveState === "saved") {
      setTimeout(() => setAutosaveState(""), 4000);
    }
  }, [autosaveState]);

  return state;
}
